module.exports = "query GetUpsaleDialogMarketingContent {\n  upsaleDialogContent: multiParagraph(id: 69) {\n    ...MarketingMultiParagraphFragment\n  }\n}\n"